export default __webpack_public_path__ + "slices/main/assets/public/media/ca_21q2haw_toolkit1_ebook_cover.ec9caaafb25a1d772a353e7369cc598c.png";